export const CREATE_LOCALE_KEY = "CREATE_LOCALE_KEY";